var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { MessageConfig } from './message-config';
var MessageContainerComponent = /** @class */ (function () {
    function MessageContainerComponent(defaultConfig, config) {
        this.messages = [];
        this.currentMessage = null;
        this.config = __assign({}, defaultConfig, config);
        // console.log(this.currentMessage);
    }
    // Create a new message
    MessageContainerComponent.prototype.createMessage = function (message) {
        var el = window.document.querySelector(".header ");
        if (el) {
            var rect = el.getBoundingClientRect();
            this.style = {
                marginTop: rect.height + "px"
            };
        }
        this.currentMessage = message;
        if (this.messages.length >= this.config.MaxStack) {
            this.messages.splice(0, 1);
        }
        message.options = this._mergeMessageOptions(message.options);
        this.messages.push(message);
    };
    // Remove a message by messageId
    MessageContainerComponent.prototype.removeMessage = function (messageId) {
        var _this = this;
        this.messages.some(function (message, index) {
            if (message.messageId === messageId) {
                _this.messages.splice(index, 1);
                return true;
            }
        });
    };
    // Remove all messages
    MessageContainerComponent.prototype.removeMessageAll = function () {
        this.messages = [];
    };
    // Merge default options and cutom message options
    MessageContainerComponent.prototype._mergeMessageOptions = function (options) {
        var defaultOptions = {
            Duration: this.config.Duration,
            Animate: this.config.Animate,
            PauseOnHover: this.config.PauseOnHover
        };
        return __assign({}, defaultOptions, options);
    };
    return MessageContainerComponent;
}());
export { MessageContainerComponent };
